import type {Editor, RichTextEditorAction} from 'grapesjs';

/** `editor.RichTextEditor` (the RichTextEditorModule type is not exported). */
type RteManager = Editor['RichTextEditor'];
/** The RTE instance passed to `result`/`update` callbacks (class not exported directly). */
type RteInstance = Parameters<RichTextEditorAction['result']>[0];

export function addBasicRteActions(rte: RteManager): void {
  rte.add('divider', {
    icon: '<div class=""></div>',
    attributes: {
      class: 'rte-action-divider spacing-m-l-1 bg-neutral-18 radius-round',
    },
    result: () => {
      return;
    },
  });

  rte.add('bold', {
    icon: '<i class="pmw-icon icon-bold rte-icon spacing-p-2"></i>',
    attributes: {title: window.i18next.t('pmwjs_bold')},
    result: (rteInstance: RteInstance) => {
      rteInstance.exec('bold');
    },
  });

  rte.add('italic', {
    icon: '<i class="pmw-icon icon-italic rte-icon spacing-p-2"></i>',
    attributes: {title: window.i18next.t('pmwjs_italic')},
    result: (rteInstance: RteInstance) => {
      rteInstance.exec('italic');
    },
  });

  rte.add('underline', {
    icon: '<i class="pmw-icon icon-underline rte-icon spacing-p-2"></i>',
    attributes: {title: window.i18next.t('pmwjs_underline')},
    result: (rteInstance: RteInstance) => {
      rteInstance.exec('underline');
    },
  });

  rte.add('strikethrough', {
    icon: '<i class="pmw-icon icon-strike-through rte-icon spacing-p-2"></i>',
    attributes: {title: window.i18next.t('pmwjs_strikethrough')},
    result: (rteInstance: RteInstance) => {
      rteInstance.exec('strikethrough');
    },
  });
}
